export default __webpack_public_path__ + "static/home_cards_argentina-b21dc632c403de9d93607ec836f39624.png";